import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import toast from "react-hot-toast";
import { handleError } from "../../utils/handleError";
import { useDispatch } from "react-redux";
import {
  activateMembership,
  getAllMembershipsAPI,
} from "../../services/memberships/membershipService";
import { setListMemberships } from "../../redux/slice/membershipsSlice";

const ModalActivateMembership = ({
  open,
  setOpen,
  membershipData,
  setLoading,
}) => {
  const dispatch = useDispatch();
  const handleDelete = async () => {
    try {
      setLoading(true);
      await activateMembership({ planId: membershipData?._id });
      const responseMemberships = await getAllMembershipsAPI();
      dispatch(
        setListMemberships({ listMemberships: responseMemberships ?? [] })
      );
      toast.success(
        `Membresía ${membershipData?.planName ?? ""} desactivada correctamente.\n La membresia aparecerá como archivada en Stripe.`
      );
      setLoading(false);
      setOpen(false);
    } catch (error) {
      const { message } = handleError(error);
      setLoading(false);
      setOpen(false);
      toast.error(
        `Error al desactivar la membresía. Por favor, inténtalo de nuevo. \n ${message}`
      );
    }
  };
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1, // tono naranja advertencia
          fontWeight: "bold",
        }}
      >
        ¿Deseas activar la membresía {membershipData?.planName ?? ""}?
      </DialogTitle>
      <DialogContent>
        <Typography>
          Al activar esta membresía los usuarios podrán contratarla.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ display: "flex", gap: 3 }}>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
          onClick={() => {
            setOpen(false);
          }}
          startIcon={<CancelIcon />}
        >
          Cancelar
        </Button>
        <Button
          variant="outlined"
          color="white"
          onClick={handleDelete}
          startIcon={<DeleteForeverIcon />}
        >
          Activar Membresía
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ModalActivateMembership;
